var codeblock_default = {
  "blockStyleSpacing": "TctK-",
  "codeBlock": "s53nJ TctK-",
  "renderedInTable": "pJQgu"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
